module.exports = __webpack_public_path__ + "static/media/thumbnail.890f4c0b.jpg";